// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.venue-creator {
  display: flex;
  align-items: center;
  align-items: center;
  margin-top: 6px;
  margin-right: 20px;
}
.venue-creator .select-venue, .venue-creator .edit-venue {
  display: inline-block;
  margin-right: 12px;
  flex-grow: 1;
}
.venue-creator .edit-venue {
  font-size: 24px;
  cursor: pointer;
  flex-grow: 0;
}
.venue-creator .position-preview {
  height: 26px;
  border-radius: 5px;
  width: 66px;
  border: none;
  margin-right: 10px;
  color: gray;
  background-color: rgba(255, 255, 255, 0.911);
}
.venue-creator .geo-search .input-container {
  margin-bottom: 0px;
}
.venue-creator .geo-search .selected-result .result-label {
  padding-left: 26px;
}
.venue-creator .geo-search .selected-result .close-icon {
  left: 4px;
  right: auto;
  top: 11px;
}
.venue-creator .geo-search-row .input-container {
  position: relative;
  z-index: 3;
}
.venue-creator .geo-search-row .input-container .tooltip-icon {
  z-index: 3;
}
.venue-creator .venue-popup .overlay-container {
  max-width: 600px;
  overflow: visible;
}
.venue-creator .venue-popup .select-box {
  overflow: visible;
}
.venue-creator .position-row {
  display: flex;
}
.venue-creator .position-input {
  position: relative;
  z-index: 1;
  flex-grow: 1;
}
.venue-creator .position-input:nth-child(1) {
  margin-right: 6px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/venue-creator/venue-creator.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AACJ;AACI;EACI,qBAAA;EACA,kBAAA;EACA,YAAA;AACR;AAEI;EACI,eAAA;EACA,eAAA;EACA,YAAA;AAAR;AAGI;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,4CAAA;AADR;AAKQ;EACI,kBAAA;AAHZ;AAMQ;EACI,kBAAA;AAJZ;AAOQ;EACI,SAAA;EACA,WAAA;EACA,SAAA;AALZ;AASI;EACI,kBAAA;EACA,UAAA;AAPR;AASQ;EACI,UAAA;AAPZ;AAWI;EACI,gBAAA;EAEA,iBAAA;AAVR;AAaI;EACI,iBAAA;AAXR;AAcI;EACI,aAAA;AAZR;AAeI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AAbR;AAgBI;EACI,iBAAA;AAdR","sourcesContent":[".venue-creator {\n    display: flex;\n    align-items: center;\n    align-items: center;\n    margin-top: 6px;\n    margin-right: 20px;\n\n    .select-venue, .edit-venue {\n        display: inline-block;\n        margin-right: 12px;\n        flex-grow: 1;\n    }\n\n    .edit-venue {\n        font-size: 24px;\n        cursor: pointer;\n        flex-grow: 0;\n    }\n    \n    .position-preview {\n        height: 26px;\n        border-radius: 5px;\n        width: 66px;\n        border: none;\n        margin-right: 10px;\n        color: gray;\n        background-color: rgba(255, 255, 255, 0.911);\n    }\n\n    .geo-search {\n        .input-container {\n            margin-bottom: 0px;\n        }\n        \n        .selected-result .result-label {\n            padding-left: 26px;\n        }\n    \n        .selected-result .close-icon {\n            left: 4px;\n            right: auto;\n            top: 11px;\n        }\n    }\n\n    .geo-search-row .input-container {\n        position: relative;\n        z-index: 3;\n\n        .tooltip-icon {\n            z-index: 3;\n        }\n    }\n\n    .venue-popup .overlay-container {\n        max-width: 600px;\n        // height: 50vh;\n        overflow: visible\n    }\n    \n    .venue-popup .select-box {\n        overflow: visible\n    }\n\n    .position-row {\n        display: flex;\n    }\n\n    .position-input {\n        position: relative;\n        z-index: 1;\n        flex-grow: 1;\n    }\n\n    .position-input:nth-child(1) {\n        margin-right: 6px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
